export default "assets/images/icons/mail-1c183ae1.svg";